import classNames from 'classnames';

import { Button } from '@crazyegginc/hatch';

import { useModal } from '/src/hooks';
import { Modal } from '/src/contexts/modal';

import IntroGAGif from '@crazyegginc/hatch/dist/animations/intro-ga-connect-tour.gif';
import GaPropertySwitcherGif from '@crazyegginc/hatch/dist/animations/intro-ga-property-switcher.gif';

export const GA_FIRST_VISIT_TYPE = {
  GA_INTRO: 'GA_INTRO',
  GA_PROPERTY_SWITCHER: 'GA_PROPERTY_SWITCHER',
};

export const GA_FIRST_VISIT_STORAGE_KEYS = {
  [GA_FIRST_VISIT_TYPE.GA_INTRO]: 'hasSeenGAModal',
  [GA_FIRST_VISIT_TYPE.GA_PROPERTY_SWITCHER]: 'hasSeenGAPropertySwitcherModal',
};

export const FIRST_VISIT_MODAL_FLOW = [
  {
    type: GA_FIRST_VISIT_TYPE.GA_INTRO,
    storageKey: GA_FIRST_VISIT_STORAGE_KEYS[GA_FIRST_VISIT_TYPE.GA_INTRO],
  },
  {
    type: GA_FIRST_VISIT_TYPE.GA_PROPERTY_SWITCHER,
    storageKey: GA_FIRST_VISIT_STORAGE_KEYS[GA_FIRST_VISIT_TYPE.GA_PROPERTY_SWITCHER],
  },
];

function getSourceByType(type) {
  switch (type) {
    case GA_FIRST_VISIT_TYPE.GA_INTRO:
      return IntroGAGif;
    case GA_FIRST_VISIT_TYPE.GA_PROPERTY_SWITCHER:
      return GaPropertySwitcherGif;
    default:
      return IntroGAGif;
  }
}

function titleByType(type) {
  switch (type) {
    case GA_FIRST_VISIT_TYPE.GA_INTRO:
      return 'New: Import Google Analytics 4 (GA4) data into Web Analytics';
    case GA_FIRST_VISIT_TYPE.GA_PROPERTY_SWITCHER:
      return 'Your Google Analytics 4 (GA4) data is ready in Web Analytics';
    default:
      return 'New: Import Google Analytics 4 (GA4) data into Web Analytics';
  }
}

function descriptionByType(type) {
  switch (type) {
    case GA_FIRST_VISIT_TYPE.GA_INTRO:
      return `Keep using your existing Google Analytics 4 data for traffic reporting, but with Crazy Egg's straightforward, easy-to-use dashboards. `;
    case GA_FIRST_VISIT_TYPE.GA_PROPERTY_SWITCHER:
      return `We’ve successfully imported your Google Analytics property and created a dedicated Web Analytics dashboard for it.`;
    default:
      return `Keep using your existing Google Analytics 4 data for traffic reporting, but with Crazy Egg's straightforward, easy-to-use dashboards. `;
  }
}

function calloutByType(type) {
  switch (type) {
    case GA_FIRST_VISIT_TYPE.GA_INTRO:
      return `No new tracking scripts to install. No spending hours on report configuration. All thanks to Crazy Egg's new integration with GA4. 100% free.`;
    case GA_FIRST_VISIT_TYPE.GA_PROPERTY_SWITCHER:
      return `If you’ve connected multiple properties, each property has its own dashboard.`;
    default:
      return `No new tracking scripts to install. No spending hours on report configuration. All thanks to Crazy Egg's new integration with GA4. 100% free.`;
  }
}

function ctaByType(type) {
  switch (type) {
    case GA_FIRST_VISIT_TYPE.GA_INTRO:
      return 'Connect Google Analytics';
    case GA_FIRST_VISIT_TYPE.GA_PROPERTY_SWITCHER:
      return 'View Web Analytics Dashboard';
    default:
      return 'Connect Google Analytics';
  }
}

export function InstructionalModal({ onClose = null, type = GA_FIRST_VISIT_TYPE.GA_INTRO }) {
  const modal = useModal();

  const handleClose = () => {
    modal.close();
    onClose?.();
  };

  if (window.isE2E) {
    return null;
  }

  return (
    <Modal
      dialogClassName={classNames('!w-[640px] !p-0 overflow-hidden', {
        '!max-h-[590px]': [GA_FIRST_VISIT_TYPE.GA_PROPERTY_SWITCHER].includes(type),
      })}
      onDismiss={handleClose}
    >
      <div className="relative w-full -z-[1]">
        <div className="w-full px-10 pt-10 bg-solitude-500 overflow-hidden">
          <img src={getSourceByType(type)} alt="" role="presentation" className="h-full w-full block" />
        </div>
        <div className="w-full border-t border-t-mystic-500 p-[30px]">
          <h4 className="flex items-center text-xl font-semibold text-black-pearl-500 mb-2">{titleByType(type)}</h4>
          <p className="text-sm text-black-pearl-500 leading-tight mb-2">{descriptionByType(type)}</p>
          <p className="text-sm text-black-pearl-500 leading-tight mb-6 flex">{calloutByType(type)}</p>
          <Button className="self-start" onClick={handleClose}>
            {ctaByType(type)}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
